import { ReferenceInput, SelectInput } from "react-admin";

import React from "react";

const UniversityInput = (props) => (
  <ReferenceInput
    {...props}
    reference="universities"
    perPage={1000}
    filter={{ connected: true }}
    allowEmpty
  >
    <SelectInput optionText="name" emptyText="ra.action.all" />
  </ReferenceInput>
);
export default UniversityInput;
